import { getAuth } from "firebase/auth";

export async function sendNewPostNotification(postId) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User not logged in");
  }

  // Lấy Firebase ID Token
  const token = await user.getIdToken();

  // Gọi Cloud Function
  const res = await fetch(
    `https://sendnewpostnotification-vbnbnaa5aq-uc.a.run.app?post_id=${postId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );

  const data = await res.json();
  return data;
}